class I18nError extends Error {
  constructor(message, error) {
    super(error)
    this.name = 'I18nError'
    this.message = message
  }
}
export default I18nError
